import React, { useState, useEffect } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { CgSpinner } from "react-icons/cg";
import MonthlyContract from "../contractPdf/MonthlyContract/MonthlyContract";

const GenerateContract = ({
  openGenerateQuotation,
  setOpenGenerateQuotation,
  InitialSelectedTItles,
  list,
  contractDetails,
}) => {
  const [checkboxArray, setCheckboxArray] = useState([
    {
      col: "Actual Profession",
      title: "actual_profession",
    },
    {
      col: "Visa Profession",
      title: "visa_profession",
    },
    {
      col: "Profession Level",
      title: "profession_level",
    },
    {
      col: "Gender",
      title: "gender",
    },
    {
      col: "Nationality",
      title: "nationality",
    },
    {
      col: "Quantity",
      title: "quantity",
    },
    {
      col: "Basic",
      title: "basic",
    },
    {
      col: "Food",
      title: "food",
    },
    {
      col: "Total - Employee Salary Package",
      title: "total_employee_salary_package",
    },
    {
      col: "Total - Government Fees",
      title: "total_government_fees",
    },
    {
      col: "Total - Soundline Fees",
      title: "total_soundline_fees",
    },
  ]);

  const HEADERS_DATA = list?.quotation_cost_sheet_heading;

  const [GenerateList, setGenerateList] = useState(InitialSelectedTItles);
  const [disableCheckbox, setDisableCheckbox] = useState(false);
  const [onChangeValue, setOnchangeValue] = useState({ obj: {}, value: "" });
  const [notesData, setNotesData] = useState([]);
  const [termsData, setTermsData] = useState([]);

  //   useEffect(() => {
  //     const notes = list?.notes?.filter((item) => item.status == "Active");
  //     setNotesData(notes);
  //     const terms = list?.terms_and_condition?.filter(
  //       (item) => item.status == "Active"
  //     );
  //     setTermsData(terms);
  //   }, [list]);

  useEffect(() => {
    const name = onChangeValue.obg?.col;
    const value = onChangeValue.value;
    if (GenerateList.length === 9 && value === true) {
      setDisableCheckbox(true);

      const filteredArray = GenerateList.filter((item) => item?.col !== name);

      setGenerateList(filteredArray);
    } else {
      setDisableCheckbox(false);
      if (value === true) {
        setGenerateList((prev) => [...prev, onChangeValue.obg]);
      } else {
        const filteredArray = GenerateList.filter((item) => item?.col !== name);

        setGenerateList(filteredArray);
      }
    }
  }, [onChangeValue]);

  useEffect(() => {
    if (GenerateList.length === 9) {
      const isTotalMonthly = GenerateList?.filter(
        (item) => item.col === "Total Monthly Per Head Cost"
      );
      if (
        isTotalMonthly.length !== 0 &&
        GenerateList[GenerateList.length - 1].col !==
          "Total Monthly Per Head Cost"
      ) {
        const filteredArray = GenerateList?.filter(
          (item) => item.col !== "Total Monthly Per Head Cost"
        );
        const copiedArray = [...filteredArray];
        copiedArray.push({
          col: "Total Monthly Per Head Cost",
          title: "total_monthly_cost_head",
        });
        setGenerateList(copiedArray);
      }
    }
  }, [GenerateList]);

  const OnChangeHandler = (value, item) => {
    setOnchangeValue({ obg: item, value: value });
  };

  useEffect(() => {
    const costSheetHeadings = list?.contract_cost_sheet_headings?.map(
      (heading) => {
        return {
          col:
            heading?.rate_category_item?.name ||
            heading?.rate_category_item_name,
          title: String(
            heading?.rate_category_item?.name ||
              heading?.rate_category_item_name
          )
            .trim()
            .split(" ")
            .join("_")
            .toLowerCase(),
        };
      }
    );

    // // Filter out duplicates based on the 'col' property
    // const uniqueCostSheetHeadings = costSheetHeadings.filter(
    // (heading, index, self) =>
    //   index === self.findIndex((h) => h.col === heading.col)
    // );
    let uniqueHeadings;
    checkboxArray?.map((checkbox) => {
      uniqueHeadings = costSheetHeadings.filter(
        (heading) =>
          heading.title !== checkbox.title &&
          heading.title !== "food" &&
          heading.title !== "basic"
      );
    });

    setCheckboxArray([
      ...checkboxArray,
      ...uniqueHeadings,
      {
        col: "Total Monthly Per Head Cost",
        title: "total_monthly_cost_head",
      },
    ]);
  }, []);

  console.log(GenerateList, "generatelists");

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        openGenerateQuotation ? "flex" : "hidden"
      }`}
    >
      <form className="max-w-3xl w-full h-auto   bg-white  rounded-md p-5">
        <h2 className="text-lg font-bold">CHOOSE FIELDS</h2>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p className="text-sm uppercase">select fields between 3 to 9</p>
          <p className="text-xs font-semibold text-slate-600">
            {GenerateList.length + "/9 Selected"}
          </p>
        </div>
        <div className="my-4 grid grid-cols-2 gap-2 uppercase overflow-y-scroll max-h-[20rem]">
          {checkboxArray?.map((item, index) => (
            <div key={index} className="form-control w-fit">
              <label className="cursor-pointer label">
                <input
                  disabled={
                    disableCheckbox &&
                    !GenerateList.some((check) => check.col == item.col)
                  }
                  onChange={(e) => OnChangeHandler(e.target.checked, item)}
                  type="checkbox"
                  checked={GenerateList.some((check) => check.col == item.col)}
                  className="checkbox  checkbox-accent"
                />
                <span className="label-text ml-2 font-semibold font-lg">
                  {item.col}
                </span>
              </label>
            </div>
          ))}
        </div>
        <div className="flex gap-3 justify-center items-center m-5">
          <button
            className="p-2  max-w-xs-ultra w-full rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setOpenGenerateQuotation(false);
            }}
          >
            CANCEl
          </button>
          {(list?.contract?.quotation_type?.name === "Monthly" &&
            GenerateList.length <= 9 &&
            GenerateList.length >= 3) ||
          (list?.contract?.quotation_type?.name === "Hourly" &&
            GenerateList.length <= 9 &&
            GenerateList.length >= 3) ? (
            <button
              type="button"
              onClick={() =>
                setTimeout(() => {
                  setOpenGenerateQuotation(false);
                })
              }
              className="p-2 bg-blue max-w-xs-ultra w-full text-white rounded-md"
            >
              <PDFDownloadLink
                document={
                  <MonthlyContract
                    generatedTitles={GenerateList}
                    contractDetails={contractDetails}
                  />
                }
                fileName={"MONTHLY-ANNEXURE"}
              >
                {({ blob, url, loading, error }) =>
                  loading ? (
                    <p className="flex gap-3 items-center justify-center">
                      Loading
                      <CgSpinner className="animate-spin" />
                    </p>
                  ) : (
                    <p className="flex gap-3 items-center justify-center">
                      Download
                    </p>
                  )
                }
              </PDFDownloadLink>
            </button>
          ) : (
            <button
              className="p-2 bg-blue max-w-xs-ultra w-full text-white rounded-md opacity-50"
              disabled
            >
              Download
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default GenerateContract;
